<template>
  <div ref="imageWrapper">
    <van-popup @close="close" v-model="show" get-container="#app">
      <div class="Modal">
        <div class="title">
          <span>{{ title }}</span>
          <span v-if="isClose" @click="determine('isClose')"
            ><van-icon name="cross"
          /></span>
        </div>
        <div class="classCapacity">
          <slot></slot>
        </div>
        <div class="determine">
           长按保存二维码
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import html2canvas from 'html2canvas';

function getBlob(base64) {
  const mimeStr = base64.split(',')[0].split(':')[1].split(';')[0]; // mime类型
  const byteStr = atob(base64.split(',')[1]); // base64 解码
  const arrayBuffer = new ArrayBuffer(byteStr.length); // 创建缓冲数组
  const intArray = new Uint8Array(arrayBuffer); // 创建视图
  for (let i = 0; i < byteStr.length; i += 1) {
    intArray[i] = byteStr.charCodeAt(i);
  }
  return new Blob([intArray], {
    type: mimeStr,
  });
}
export default {
  name: 'SeftPopup',
  data() {
    return {
      show: false,
    };
  },
  props: {
    value: Boolean,
    isClose: Boolean,
    imgUrl: String,
    title: String,
    btnText: String,
    imageBox: HTMLImageElement,
  },
  watch: {
    value: {
      handler(val) {
        this.show = val;
      },
      immediate: true,
    },
    show: {
      handler(val) {
        if (!val) {
          this.$emit('input', false);
        }
      },
      immediate: true,
    },
  },
  mounted() {
    // html2canvas(this.$refs.imageWrapper).then((canvas) => {
    //   const dataURL = canvas.toDataURL('image/png');
    //   this.imgUrl = dataURL;
    //   if (this.imgUrl !== '') {
    //     this.dialogTableVisible = true;
    //   }
    // });
  },
  methods: {
    determine(val) {
      if (val === 'isClose') {
        this.show = false;
        this.$emit('close');
        return;
      }
      if (this.imageBox !== null) {
        this.show = false;
        const a = document.createElement('a');
        const blob = getBlob(this.imageBox.src); 
        const urlLink = window.URL.createObjectURL(blob);
        a.href = urlLink;
        // 设置下载文件的名字
        a.download = '下载';
        // 点击
        a.click();
      }
    },
    close() {
      this.$emit('close');
      this.show = false;
    },
  },
};
</script>
<style scoped>
.Modal {
  min-height: 250px;
  background: #fff;
  border-radius: 12px;
}
.determine {
  width: 100%;
  height: 56px;
  color: #999;
  text-align: center;
  font-weight: 700;
  font-size: 13px;
  line-height: 56px;
  border-top: 1px solid #ebf1f5;
}
.title {
  font-family: PingFangSC-Medium;
  font-size: 18px;
  color: rgba(80, 80, 80, 1);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #ebf1f5;
}
.classCapacity {
  min-height: 90px;
  padding: 12px 16px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.inputPic {
  border: 0;
  width: 50%;
}
.van-popup {
  width: 85%;
  border-radius: 12px !important;
}
.determineLeft {
  font-family: PingFangSC-Regular;
  font-size: 16px;
  font-weight: 100;
  letter-spacing: 0;
  height: 44px;
  margin: 16px 16px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  background: #ff6538;
  outline: none;
  border:none;
  width:100%;
}
.determineLeft[disabled] {
  font-family: PingFangSC-Regular;
  font-size: 16px;
  font-weight: 100;
  letter-spacing: 0;
  height: 44px;
  margin: 16px 16px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  background: #9EA7B4;
  outline: none;
  border:none;
  width:100%;
}

.imgCode {
  flex: 1;
  height: 40px;
  background: #fafafa;
}
.imgCode img {
  width: 100%;
  height: 100%;
}
</style>
